import { FC } from 'react'

import { Card } from 'ui'
import { t } from 'translations'

interface NoResultsProps {
  hideEmptySchedulerRows?: boolean
  handleUnhideEmptyRows: () => void
}

const NoResults: FC<NoResultsProps> = ({ hideEmptySchedulerRows, handleUnhideEmptyRows }) => {
  return (
    <Card className="d-flex flex-column justify-content-center align-items-center h-100 bg-light">
      <i className="fad fa-search fa-4x mb-3"></i>
      <div className=" h5 mb-2">{t('components.noResults.NO_RESULTS_FOUND')}</div>
      <small className="text-muted">{t('components.noResults.CHANGE_FILTER')}</small>
      {hideEmptySchedulerRows ? (
        <div>
          <button className="btn btn-sm btn-light" type="button" onClick={handleUnhideEmptyRows}>
            <i className="fas fa-eye" aria-hidden="true"></i>
          </button>
          <small className="ml-1 text-muted">{t('components.noResults.CHANGE_VIEW')}</small>
        </div>
      ) : null}
    </Card>
  )
}

export default NoResults
